import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-bootstrap'
import { connect } from 'react-redux'
import FormattedConnectedInput from './FormattedConnectedInput'
import * as forms from './form'
import { updateSectionFormLines } from '../../redux/app-reducer'
import addFormLineImg from '../images/form-line-add-plus.png'
import addFormLineImgLight from '../images/form-line-add-plus-light.png'
import ImgButton from '../foundation/ImgButton'
import FormNumberTotal from './FormNumberTotal'

/**
 * Smart component for rendering a growing list of inputs for dynamic label
 * dollar amounts
 */
class DynamicGrowForm extends Component {
  /**
   * c'tor
   */
  constructor (props) {
    super(props)
    if (!this.props.formLines) {
      this.props.dispatch(
        updateSectionFormLines(this.props.reduxFormLinesKey, 1)
      )
    }
    this.handleAddLineClick = this.handleAddLineClick.bind(this)
  }

  /**
   * Handle React event
   */
  componentWillMount () {
    this.setState({
      formKeys: forms.getFormKeysArray(
        this.props.sectionNumber,
        this.props.formLines
      )
    })
  }

  /**
   * Handle React event
   */
  componentWillReceiveProps (nextProps) {
    if (nextProps.formLines !== this.props.formLines) {
      this.setState({
        formKeys: forms.getFormKeysArray(
          nextProps.sectionNumber,
          nextProps.formLines
        )
      })
    }
  }

  /**
   * Handle button click to add an input line
   * @param event
   */
  handleAddLineClick (event) {
    const newTotal = this.props.formLines + 1
    const formKeys = forms.getFormKeysArray(this.props.sectionNumber, newTotal)
    this.setState({ formKeys })
    this.props.dispatch(
      updateSectionFormLines(this.props.reduxFormLinesKey, newTotal)
    )
  }

  /**
   *
   */
  render () {
    return (
      <div>
        <Form style={forms.formWrapperStyle} horizontal>
          {this.state.formKeys.map(formKey => (
            <FormattedConnectedInput
              labelInput
              reduxKey={formKey}
              key={formKey}
              dollarForm
            />
          ))}
          <ImgButton
            imgSrc={addFormLineImg}
            mouseOverSrc={addFormLineImgLight}
            onButtonClick={this.handleAddLineClick}
            altText='Add Form Line Item'
          />
        </Form>
        <FormNumberTotal
          formKeys={this.state.formKeys}
          sectionNumber={this.props.sectionNumber}
        />
      </div>
    )
  }
}

DynamicGrowForm.propTypes = {
  reduxFormLinesKey: PropTypes.string.isRequired,
  sectionNumber: PropTypes.number.isRequired
}

export function mapStateToProps (state, ownProps) {
  return {
    formLines: state.get('app').get(ownProps.reduxFormLinesKey)
  }
}

export default connect(mapStateToProps)(DynamicGrowForm)



// WEBPACK FOOTER //
// ./src/components/forms/DynamicGrowForm.js